<template>
	<p class="text_input_num"><span :class="{'textCout' : checktext ? 'textCout' : ''}">{{remaining}}</span> / {{maxlength}} byte</p>

	<textarea name="textcont" class="textarea_type1"
		:placeholder="placeholder"
		v-model="checktext" 
		:maxlength="maxlength">
	</textarea>
</template>

<script>
export default {
	props: {
		placeholder : String,
        maxlength : {
            type: Number,
            default : 2000
        },
		modelValue: {
			type: String,
			default: ''
		}
	},
    data() {
        return {
            checktext: this.modelValue,
        }
    },
    methods: {

    },
    watch: {
		// checktext가 변경될 때 부모에게 업데이트
		checktext(newValue) {
			this.$emit('update:modelValue', newValue);
		},
		// 부모로부터 modelValue가 변경되었을 때 checktext도 업데이트
		modelValue(newValue) {
			this.checktext = newValue;
		}
	},
    computed: {
        remaining: function() {
            return this.checktext.length;
        }
    }
}
</script>
